import React from "react";
import { Box, Card, CardContent, CardActions, Typography, Button } from "@mui/material";
import { Payment as PaymentIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import AddBalance from "./AddBalance";
import AddPromo from "../../../../../Business/modules/Credits/components/AddPromo";
import {
  canApplyPromoInOfferFlow,
  resolveMinimumLaunchBalance,
} from "utils/businessBalance";
import AutoReloadPreference, {
  FORM_COLUMN_AUTO_RELOAD_SX,
} from "modules/Business/components/AutoReloadPreference";

const PaymentMethodCard = ({
  business,
  onAddFundSuccess,
  addBalanceRef,
  autoReloadPreference,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [showPromoPopup, setShowPromoPopup] = React.useState(false);
  const liveBusiness = useSelector((state) => state.business);

  const accountBalance = liveBusiness.accountBalance ?? business?.accountBalance;
  const paymentBusiness = liveBusiness.paymentRules ? liveBusiness : business;

  if (!business?.card) return null;

  const handleEnterPromoClick = () => {
    if (!canApplyPromoInOfferFlow(accountBalance, paymentBusiness)) {
      const minimum = resolveMinimumLaunchBalance(paymentBusiness);
      enqueueSnackbar(
        `Please add at least $${minimum} to your account before using a promo code`,
        { variant: "warning" }
      );
      return;
    }
    setShowPromoPopup(true);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">Add fund to launch offer</Typography>

        <Box display="flex" alignItems="center" pt={2}>
          <PaymentIcon fontSize="small" style={{ marginRight: 8 }} />
          <Typography variant="body1" color="textSecondary">
            {business.card.brand} **** **** **** {business.card.last4} - {business.card.expMonth}/{business.card.expYear}
          </Typography>
        </Box>

        <Box mt={2}>
          <AddBalance
            businessId={business.businessId}
            onFundSuccess={onAddFundSuccess}
            ref={addBalanceRef}
          />
        </Box>
        <AutoReloadPreference
          preference={autoReloadPreference}
          sx={{ ...FORM_COLUMN_AUTO_RELOAD_SX, mt: 3 }}
        />
      </CardContent>

      <CardActions sx={{ flexWrap: "wrap", gap: 1 }}>
        <Button color="primary" onClick={handleEnterPromoClick}>
          Enter promo code
        </Button>
        {showPromoPopup && (
          <AddPromo
            businessId={business.businessId}
            onClose={() => setShowPromoPopup(false)}
          />
        )}
      </CardActions>
    </Card>
  );
};

export default PaymentMethodCard;
